<template>
  <el-checkbox-group class="exam-checkbox-radio-box" v-model="checkValue[subjects.examQuestionsId]" :disabled="readOnly" @change="handleCheck">
    <el-checkbox
      v-for="(item, index) in subjects.options"
      :key="item.examQuestionsOptionsId"
      :label="item.examQuestionsOptionsId + '[-]' + item.name"
    >
      <span>
        {{ item.option }}.{{ item.name }}
        <div class="img" v-if="item.imgs">
          <template v-for="(img, i) in item.imgs">
            <el-popover
              placement="right"
              trigger="hover"
              width="200"
              :popper-options="{
                boundariesElement: 'viewport',
                removeOnDestroy: true,
              }"
              :key="i"
            >
              <el-image :src="dsf.url.getWebPath(optionImg)">
                <div slot="error" class="image-slot">
                  <i class="iconfont icon-tupianjiazaishibai err-img"></i>
                </div>
              </el-image>
              <el-image
                slot="reference"
                :key="i"
                :src="dsf.url.getWebPath(img.relativePath)"
                @mouseover="showPopver($event, index)"
                @click="showImage(item)"
              >
                <div slot="error" class="image-slot">
                  <i class="iconfont icon-tupianjiazaishibai err-img"></i>
                </div>
              </el-image>
            </el-popover>
          </template>
        </div>
      </span>
      <i
        :class="[
          'iconfont right-icon',
          previewStatus && readOnly && subjects.result
            ? subjects.result.indexOf(item.examQuestionsOptionsId) > -1
              ? subjects.answer.indexOf(item.examQuestionsOptionsId) > -1
                ? 'icon-icon_gou'
                : 'icon-icon_wrong'
              : ''
            : 'icon-icon_gou',
        ]"
      ></i>
    </el-checkbox>
  </el-checkbox-group>
</template>

<script>
export default dsf.component({
  name: "DsfExamCheckBox",
  mixins: [$mixins.examControl],
  ctrlCaption: "多选题",
  props: {
    previewStatus: {
      type: Boolean,
      default: false,
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
    metadata: {
      type: Object,
      default() {
        return dsf.metadata.get("exam-items-meta-data");
      },
    },
  },
  data() {
    return {
      optionImg: "",
    };
  },
  methods: {
    showImage(item) {
      this.$emit("show-image", item.imgs);
    },
    showPopver(e, index) {
      // console.log(e, index);
      this.$nextTick(() => {
        if (e.target.nodeName.toLowerCase() === "img") {
          // this.$refs.optspopover[index].updatePopper(); // 用来重新计算位置
          this.optionImg = e.target.src;
          // this.$refs.optspopover[index].doShow();
        } else {
          this.optionImg = false;
        }
      });
    },
  },
});
</script>
